/* eslint-disable no-alert */
/* eslint-disable jsx-a11y/media-has-caption */
import React, { useEffect, useState } from 'react';
import { useUpdateEffect } from 'react-use';
import {
  Alert,
  Chip,
  Grid,
  Stack,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
  LinearProgress,
  Button,
  Paper,
  Divider,
} from '@mui/material';
import MicIcon from '@mui/icons-material/Mic';
import StopIcon from '@mui/icons-material/Stop';
import UndoIcon from '@mui/icons-material/Undo';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { styled } from '@mui/styles';
import {
  MODAL_TYPE_ROBOT_SEARCH,
  STRING_BYTE_LENGTH,
} from '../../common/consts';
import AccordionCard from '../../components/AccordionCard';
import MessageSearchModal from '../../components/message/MessageSearchModal';
import { closeModal, openModal, sendMessage } from '../../modules/messageBot';
import Toast from '../../components/Toast';
import { getManagerMode } from '../../common/util';

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  '& .MuiToggleButtonGroup-grouped': {
    margin: theme.spacing(0.5),
    border: 0,
    '&.Mui-disabled': {
      border: 0,
    },
    '&:not(:first-of-type)': {
      borderRadius: theme.shape.borderRadius,
    },
    '&:first-of-type': {
      borderRadius: theme.shape.borderRadius,
    },
  },
}));

const MSG = {
  realTime: {
    text: {
      content:
        '텍스트로 입력한 내용을 파이보의 음성으로 실시간으로 전달합니다.',
      bErr: false,
    },
    voice: {
      content: '사용자가 녹음한 내용을 파이보가 실시간으로 전달합니다.',
      bErr: false,
    },
  },
  default: {
    text: {
      content:
        '텍스트로 입력한 내용을 파이보의 음성으로 인체감지 시에 전달합니다.',
      bErr: false,
    },
    voice: {
      content: '사용자가 녹음한 내용을 파이보가 인체감지 시에 전달합니다.',
      bErr: false,
    },
  },
  all: { content: '모든 로봇에 메시지를 전달합니다.', bErr: false },
  select: { content: '메시지를 보낼 로봇을 선택하세요.', bErr: true },
  selected: { content: '선택된 로봇에 메시지를 보냅니다.', bErr: false },
  minValue: { content: '메시지 내용을 입력하세요.', bErr: true },
  overInput: {
    content: '메시지는 100자 이하(200byte)로 입력 가능합니다.',
    bErr: true,
  },
  wrongInput: {
    content:
      '메시지는 한글, 영문, 숫자, 문장부호(.,!?~)만 입력 할 수 있습니다.',
    bErr: true,
  },
  noRecord: { content: '메시지를 녹음하세요.', bErr: true },
  value: { content: '', bErr: false },
};
const initialObj = {
  mode: 'realTime',
  type: 'text',
  range: 'all',
  value: '',
};
const initialRecordState = {
  timeElapsed: 0,
  recording: false,
  message: '',
  audioURL: null,
  response: false,
  uuid: '',
};
let timer = null;
const MessageRegisterContainer = () => {
  const dispatch = useDispatch();
  const {
    modal,
    send: { pending: sending, result: sent, message: sentMessage },
  } = useSelector((state) => state.messageBot);
  const [open, setOpen] = useState(true);
  const [doneDisabled, setDoneDisabled] = useState(true);
  const [selectedRobots, setRobots] = useState(null);
  const [sendSnack, setSendSnack] = useState({ open: false });
  const [msgObj, setMessage] = useState(initialObj);
  const [error, setError] = useState({
    type: MSG.value,
    mode: MSG.value,
    range: MSG.value,
    value: MSG.value,
  });
  const [blob, setBlob] = useState(null);
  const [mediaRecorder, setMedia] = useState(null);
  const [mm, setMomentTime] = React.useState(moment().minutes(0).seconds(0));
  const [time, setTime] = React.useState(mm.format('mm:ss'));
  const [record, setRecord] = useState({ ...initialRecordState });

  let chunks = [];
  const { type, mode, range, value } = msgObj;

  const startRecording = () => {
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      navigator.mediaDevices
        .getUserMedia({ audio: true })
        .then((stream) => {
          const mr = new MediaRecorder(stream);
          setMedia(mr);
          mr.start();
          mr.ondataavailable = (e) => {
            chunks.push(e.data);
          };
          mr.onstop = () => {
            clearInterval(timer);
            const bb = new Blob(chunks, { type: 'audio/mpeg' });
            setBlob(bb);
            const audioURL = window.URL.createObjectURL(bb);
            setRecord({ ...record, audioURL });
          };
          setRecord({ ...record, recording: true });
        })
        .catch((err) => {
          // Error callback
          alert(
            `사용자의 미디어 정보를 가져오는 도중 오류가 발생했습니다: ${err}`,
          );
        });
      chunks = [];
    } else {
      alert('음성 녹음을 지원하지 않는 브라우저입니다.');
    }
  };

  const stopRecording = () => {
    mediaRecorder.stop();
  };

  const deleteRecording = () => {
    chunks = [];
    setMedia(null);
    setRecord({ ...initialRecordState });
  };

  const onItemChange = (e) => {
    const { name, value: v } = e.target;
    setMessage({ ...msgObj, [name]: v });
  };

  const onItemTypeChange = (e) => {
    const { value: v } = e.target;
    deleteRecording();
    onItemChange({ target: { name: 'type', value: v } });
  };

  const onItemModeChange = (e) => {
    const { value: v } = e.target;
    onItemChange({ target: { name: 'mode', value: v } });
  };

  const onItemRangeChange = (e) => {
    const { value: v } = e.target;
    onItemChange({ target: { name: 'range', value: v } });
    if (v === 'selected') {
      dispatch(openModal({ type: MODAL_TYPE_ROBOT_SEARCH }));
    }
  };
  const onDeleteSerialClick = (robot) => {
    const idx = selectedRobots.findIndex((item) => item.id === robot.id);
    if (idx > -1) {
      const list = [...selectedRobots];
      list.splice(idx, 1);
      setRobots(list);
    }
  };

  const handleSelectRobot = (list) => {
    setRobots(list);
    dispatch(closeModal());
  };

  const handleSendClick = () => {
    const robots = range === 'all' ? [] : selectedRobots;
    if (type === 'voice') {
      const fileName = `${new Date().valueOf()}.mp3`;
      dispatch(sendMessage({ type, mode, fileName, blob, robots }));
    } else {
      dispatch(sendMessage({ type, mode, value, robots }));
    }
  };

  const sendInitialize = () => {
    deleteRecording();
    setMessage({ ...msgObj, range: initialObj.range, value: '' });
    setRobots(null);
  };

  const handleOpen = (v) => () => {
    if (!v) {
      sendInitialize();
    }
    setOpen(v);
  };

  useEffect(() => {
    const modeErr = MSG[mode][type];
    let rangeErr = MSG[range];
    let valErr = MSG.value;

    if (type === 'text') {
      if (!value) {
        valErr = MSG.minValue;
      } else if (STRING_BYTE_LENGTH(value) > 200) {
        valErr = MSG.overInput;
      } else if (!/(^[A-Za-zㄱ-ㅎ가-힣\d\s.,!?~]*$)/g.test(value)) {
        valErr = MSG.wrongInput;
      }
    }

    if (type === 'voice' && !record.audioURL) {
      valErr = MSG.noRecord;
    }

    if (
      range === 'selected' &&
      (!selectedRobots || selectedRobots.length === 0)
    ) {
      rangeErr = MSG.select;
    }

    setError({ value: valErr, mode: modeErr, range: rangeErr });
  }, [type, mode, range, value, selectedRobots, record.audioURL]);

  useUpdateEffect(() => {
    const errVal = Object.values(error);
    const disabled = errVal.reduce((result, cur) => result || cur.bErr, false);
    setDoneDisabled(disabled);
  }, [error]);

  const handleSnackClose = () => {
    if (sent) {
      sendInitialize();
    }
    setSendSnack({ open: false });
  };

  useUpdateEffect(() => {
    if (record.recording) {
      if (timer) clearInterval(timer);
      if (!record.audioURL) {
        timer = setInterval(() => {
          setMomentTime(mm.add(1, 'seconds'));
          setTime(mm.format('mm:ss'));
        }, 1000);
      }
    } else {
      clearInterval(timer);
      setMomentTime(moment().minutes(0).seconds(0));
      setTime('00:00');
    }
  }, [record.recording]);

  useUpdateEffect(() => {
    if (sent !== null) {
      setSendSnack({
        open: true,
        onClose: handleSnackClose,
        message: sentMessage,
        severity: sent ? 'success' : 'error',
      });
    }
  }, [sent]);

  return (
    <>
      <AccordionCard
        {...{
          title: '메시지 보내기',
          done: {
            label: '보내기',
            disabled: doneDisabled,
            onClick: handleSendClick,
          },
          fold: { label: '취소', onClick: handleOpen(false) },
          unfold: { label: '메시지 쓰기', onClick: handleOpen(true) },
        }}
        open={open}
      >
        {sending && <LinearProgress color="secondary" sx={{ my: 3 }} />}
        {!sending && (
          <Grid container spacing={2}>
            <Grid container item xs={12} spacing={2}>
              <Grid item xs={12} md={6}>
                <Stack
                  gap={1}
                  sx={{ alignItems: { xs: 'initial', sm: 'baseline' } }}
                >
                  <Typography variant="body2">전달방식 및 형식</Typography>
                  <Paper
                    elevation={0}
                    sx={{
                      display: 'flex',
                      border: (theme) => `1px solid ${theme.palette.divider}`,
                      minWidth: { xs: '100%', sm: '40%', lg: '50%' },
                    }}
                  >
                    <StyledToggleButtonGroup
                      color="secondary"
                      name="mode"
                      value={mode}
                      exclusive
                      onChange={onItemModeChange}
                      sx={{
                        '& button': { width: '100%' },
                        width: '48%',
                      }}
                    >
                      <ToggleButton value="realTime">실시간</ToggleButton>
                      <ToggleButton value="default">인체감지</ToggleButton>
                    </StyledToggleButtonGroup>
                    <Divider
                      flexItem
                      orientation="vertical"
                      sx={{ mx: 0.5, my: 1 }}
                    />
                    <StyledToggleButtonGroup
                      color="secondary"
                      name="type"
                      value={type}
                      exclusive
                      onChange={onItemTypeChange}
                      sx={{
                        '& button': { width: '100%' },
                        width: '48%',
                      }}
                    >
                      <ToggleButton value="text">텍스트</ToggleButton>
                      <ToggleButton value="voice">음성</ToggleButton>
                    </StyledToggleButtonGroup>
                  </Paper>
                </Stack>
              </Grid>
              <Grid item xs={12} md={6} sx={{ order: { xs: 1, md: 0 } }}>
                {type === 'text' && (
                  <Stack gap={1}>
                    <Stack direction="row" justifyContent="space-between">
                      <Typography variant="body2">메시지 내용</Typography>
                      <Typography variant="body2">
                        {`${STRING_BYTE_LENGTH(value)}/200`}
                      </Typography>
                    </Stack>
                    <TextField
                      id="outlined-value-static"
                      name="value"
                      placeholder="내용을 입력하세요"
                      rows={2}
                      onChange={onItemChange}
                      value={value}
                      fullWidth
                      multiline
                    />
                  </Stack>
                )}
                {type === 'voice' && (
                  <Stack gap={1} alignItems="baseline">
                    <Typography variant="body2">메시지 녹음</Typography>
                    {!record.recording && !record.audioURL && (
                      <Button
                        variant="contained"
                        color="secondary"
                        startIcon={<MicIcon />}
                        onClick={startRecording}
                        fullWidth
                        size="large"
                      >
                        녹음
                      </Button>
                    )}
                    {record.recording && (
                      <Stack direction="row" gap={1} alignItems="center">
                        <Button
                          variant="contained"
                          color="error"
                          startIcon={<StopIcon />}
                          onClick={stopRecording}
                          size="large"
                        >
                          정지
                        </Button>
                        <div>{time}</div>
                      </Stack>
                    )}
                    {!record.recording && record.audioURL && (
                      <Stack direction="row" gap={1} alignItems="center">
                        <Button
                          variant="outlined"
                          color="secondary"
                          startIcon={<UndoIcon />}
                          onClick={deleteRecording}
                          size="large"
                        >
                          취소
                        </Button>
                        <audio
                          controls
                          src={record.audioURL}
                          style={{ flex: '1 1' }}
                        />
                      </Stack>
                    )}
                  </Stack>
                )}
              </Grid>
              <Grid item xs={12} md={6}>
                <Alert severity={error.mode.bErr ? 'error' : 'info'}>
                  {error.mode.content}
                </Alert>
              </Grid>
              <Grid item xs={12} md={6} sx={{ order: { xs: 1, md: 0 } }}>
                {error.value.content && (
                  <Alert severity={error.value.bErr ? 'error' : 'info'}>
                    {error.value.content}
                  </Alert>
                )}
              </Grid>
            </Grid>
            <Grid item xs={12} md={6}>
              {!getManagerMode() && (
                <Stack gap={1}>
                  <Typography variant="body2">보낼 로봇 선택</Typography>
                  <Stack
                    sx={{ flexDirection: { xs: 'column', sm: 'row' } }}
                    gap={1}
                  >
                    <Paper
                      elevation={0}
                      sx={{
                        display: 'flex',
                        border: (theme) => `1px solid ${theme.palette.divider}`,
                        minWidth: { xs: '100%', sm: '40%', lg: '50%' },
                      }}
                    >
                      <StyledToggleButtonGroup
                        color="secondary"
                        value={range}
                        name="range"
                        exclusive
                        onChange={onItemRangeChange}
                        sx={{ '& button': { width: '100%' }, width: '100%' }}
                      >
                        <ToggleButton value="all">모든 로봇</ToggleButton>
                        <ToggleButton value="selected">로봇 선택</ToggleButton>
                      </StyledToggleButtonGroup>
                    </Paper>
                    <Alert
                      severity={error.range.bErr ? 'error' : 'info'}
                      sx={{ width: '100%' }}
                    >
                      {error.range.content}
                    </Alert>
                  </Stack>
                  <Stack direction="row" gap={1}>
                    {range === 'selected' &&
                      selectedRobots &&
                      selectedRobots.map((robot) => (
                        <Chip
                          label={robot.serial}
                          key={robot.id}
                          id={robot.id}
                          color="secondary"
                          variant="outlined"
                          onDelete={() => onDeleteSerialClick(robot)}
                        />
                      ))}
                  </Stack>
                </Stack>
              )}
            </Grid>
          </Grid>
        )}
      </AccordionCard>
      {modal.open && modal.bDel === null && (
        <MessageSearchModal
          {...{
            ...modal,
            onUpdate: handleSelectRobot,
            onCancel: () => dispatch(closeModal()),
          }}
        />
      )}
      <Toast {...{ ...sendSnack }} />
    </>
  );
};

export default MessageRegisterContainer;
